import { Stack, Flex, Text, Box } from "../../internal/exports";
import { Field } from "../../form-control/form-control";
import type { HTMLChakraProps, StackProps } from "@chakra-ui/react";

type FieldHelperTextProps = HTMLChakraProps<"div">;
type FieldErrorTextProps = HTMLChakraProps<"div">;

interface QuestionFooterProps extends StackProps {
  gap?: StackProps["gap"];
  answerLength?: number;
  notes?: string;
  maxLength?: number;
  maxLengthNote?: string;
  error?: string;
  helperTextStyles?: FieldHelperTextProps;
  errorMsgStyles?: FieldErrorTextProps;
  withErrorIcon?: boolean;
  locale?: string;
}

const QuestionFooter = (props: QuestionFooterProps) => {
  const {
    answerLength = 0,
    notes,
    maxLength = null,
    maxLengthNote,
    error,
    helperTextStyles,
    errorMsgStyles,
    gap,
    withErrorIcon,
    locale = "en",
    ...rest
  } = props;

  if (!maxLength && !error && !notes) {
    return null;
  }
  const formatNumberByLocale = (num: number) => {
    return Intl.NumberFormat(locale).format(num);
  };
  return (
    <Stack
      {...rest}
      gap={gap}
      direction="column"
      justifyContent={notes || error ? "space-between" : "flex-end"}
    >
      {error && (
        <Field.ErrorText {...{ mt: 0, ...errorMsgStyles }}>
          {withErrorIcon && <Field.ErrorIcon />} {error}
        </Field.ErrorText>
      )}
      {(maxLength || notes) && (
        <Field.HelperText width="100%" {...{ mt: 0, ...helperTextStyles }}>
          <Stack gap={gap}>
            {maxLength && maxLengthNote && (
              <Flex
                justifyContent={maxLengthNote ? "space-between" : "flex-end"}
              >
                {maxLengthNote && <Text>{maxLengthNote}</Text>}
                <Text>
                  {`${formatNumberByLocale(answerLength)}/${formatNumberByLocale(maxLength)}`}
                </Text>
              </Flex>
            )}
            {notes && <Box {...helperTextStyles}>{notes}</Box>}
          </Stack>
        </Field.HelperText>
      )}
    </Stack>
  );
};

export { QuestionFooter };
export type { QuestionFooterProps };
